module.exports = __webpack_public_path__ + "static/20-c98d57c35bc52ee80052090bf8613e8d.mp4";